export default __webpack_public_path__ + "static/media/aws.c28ea510.svg";